module.exports = __webpack_public_path__ + "static/media/platoducha.2d8c9f9f.svg";